import { defineComponent as _defineComponent } from 'vue'
import { computed, onMounted } from 'vue';

import { faTimes, faAngleLeft } from '@fortawesome/free-solid-svg-icons';

import { useModal } from '@/helpers/composables/useModal';
import { useConstantStore } from '@/helpers/composables/useStores';


export default /*#__PURE__*/_defineComponent({
  __name: 'NewDesignModal',
  props: {
    title: { default: '' },
    closable: { type: Boolean, default: true },
    hasBack: { type: Boolean },
    hasHeader: { type: Boolean, default: true },
    showDefaultTitle: { type: Boolean, default: true },
    hasLargeToolbar: { type: Boolean, default: true }
  },
  emits: ['back', 'closed'],
  setup(__props: any, { emit }) {





const ASSETS_DIRECTORY = `/${ASSETS_DIR}`;

const { providers } = useConstantStore();
const { dismiss, onWillDismiss } = useModal();

onMounted(async () => {
	await onWillDismiss();
	emit('closed');
});

const descriptionProviderList = computed(() => {
	return providers
		.value()
		.slice(0, 3)
		.map(({ clearName }: any) => ` ${clearName}`);
});

return { __sfc: true,emit, ASSETS_DIRECTORY, providers, dismiss, onWillDismiss, descriptionProviderList, faTimes, faAngleLeft }
}

})